import { render, staticRenderFns } from "./dadosAcademicos.vue?vue&type=template&id=ecb4f8ae"
import script from "./dadosAcademicos.vue?vue&type=script&lang=js"
export * from "./dadosAcademicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports